import { render, staticRenderFns } from "./BaseDocument.vue?vue&type=template&id=38d53d0c&scoped=true&"
import script from "./BaseDocument.vue?vue&type=script&lang=js&"
export * from "./BaseDocument.vue?vue&type=script&lang=js&"
import style0 from "./BaseDocument.vue?vue&type=style&index=0&id=38d53d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d53d0c",
  null
  
)

export default component.exports